export enum ConnectionType {
  DCOM = 'darty_com',
  DPRO = 'darty_pro',
}
